"use client";

import { useEffect } from "react";
import { useSpotifyPlayer } from "./spotify-player-context";

/** Sets the citySlug on the Spotify player context when a page mounts. */
export function useSetSpotifyCitySlug(citySlug: string) {
  const { setCitySlug } = useSpotifyPlayer();
  useEffect(() => {
    if (citySlug) setCitySlug(citySlug);
  }, [citySlug, setCitySlug]);
}
